import { useQuery } from "@apollo/client";
import { Alert, MenuItem, TextField } from "@mui/material";
import { PRODUCT_TYPES } from "./api";

export default function WorksheetProductTypeSelect({
  value,
  onChange,
  disabled = false,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}) {
  const { data, loading, error } = useQuery(PRODUCT_TYPES);
  const types: { id: string; name: string }[] = data?.getOrganizationProductTypes ?? [];
  return (
    <>
      {error && <Alert severity="error">{error.message}</Alert>}
      {!loading && !error && types.length === 0 && (
        <Alert severity="info">
          Create a Product Type in Product Settings before saving a Worksheet product.
        </Alert>
      )}
      <TextField
        fullWidth
        select
        size="small"
        required
        label="Product Type"
        value={value}
        disabled={disabled || loading || !!error}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="" disabled>
          Select a Product Type
        </MenuItem>
        {value && !types.some((type) => type.id === value) && (
          <MenuItem value={value} disabled>
            Unavailable Product Type
          </MenuItem>
        )}
        {types.map((type) => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
